import { render, staticRenderFns } from "./PageComponent.vue?vue&type=template&id=306a36ea&scoped=true"
import script from "./PageComponent.vue?vue&type=script&lang=js"
export * from "./PageComponent.vue?vue&type=script&lang=js"
import style0 from "./PageComponent.vue?vue&type=style&index=0&id=306a36ea&prod&lang=css"
import style1 from "./PageComponent.vue?vue&type=style&index=1&id=306a36ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306a36ea",
  null
  
)

export default component.exports